import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { InputLabel, Select } from '@material-ui/core';
import { ATIPO_CONTA_BANCO, ATIPO_CONTA_CAIXA } from 'consts';

const useStyles = makeStyles(theme => ({
    root: {},
    row: {
        height: '42px',
        display: 'flex',
        alignItems: 'left',
        marginTop: theme.spacing(1)
    },
    spacer: {
        flexGrow: 10
    },
    margin: {
        marginLeft: theme.spacing(2)
    },

}));

const ComboTipoCaixaBanco = props => {
    const { className, ...rest } = props;
    const classes = useStyles();

    function Tipos() {
        const tipos = [
            { id: ATIPO_CONTA_BANCO, descTipo: 'Banco' },
            { id: ATIPO_CONTA_CAIXA, descTipo: 'Caixa' }
        ];

        const listTipos = tipos.map(
            (tipo) => {
                return (
                    <option
                        key={tipo.id}
                        value={tipo.id}
                    >{tipo.descTipo}</option>
                )
            }
        )

        return (
            <div>
                <InputLabel
                    htmlFor="outlined-age-native-simple"
                >Tipo</InputLabel>
                <Select
                    fullWidth
                    inputProps={{
                        id: 'outlined-age-native-simple',
                        name: rest.name
                    }}
                    label={rest.label}
                    native
                    onChange={rest.onChange}
                    size
                    value={rest.value}
                >
                    {listTipos}
                </Select>
            </div>
        )
    }

    return (
        <Tipos />

    );
};

ComboTipoCaixaBanco.propTypes = {
    className: PropTypes.string
};

export default ComboTipoCaixaBanco;